import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, CircularProgress, Autocomplete, TextField, Radio, RadioGroup, FormControlLabel, Checkbox } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../../core/BaseComponents/Modal";
import { FaImage } from "react-icons/fa";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../../utils/utils";
import { faImages, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FileUploader } from "react-drag-drop-files";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DeleteBackgroundImage from "./DeleteCustomizeWelcomeScreen";
import PreviewBgImage from "./PreviewCustomizeWelcomeScreen ";
import Custom_Paingation from "../../../../core/BaseComponents/Custom_Paingation";
import { useSelector } from "react-redux";
import CustomizeWelcomeVideoDelete from "./CustomizeWelcomeVideoDelete";
import { FaArrowsRotate } from "react-icons/fa6";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ImageResolutionTooltip from "../../../ConfigurationNewHotel/ImageResolutionTooltip";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function CustomizeWelcomeScreen() {

  const [welcomeScreenList, setWelcomeScreenList] = useState([]);
  const [confirmDeleteWelcomeScreenRow, setConfirmDeleteWelcomeScreenRow] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deleteWelcomeScreenPopUp, setDeleteWelcomeScreenPopUp] = useState(false);
  const [editWelcomeScreen, setEditWelcomeScreen] = useState(true);
  const [editWelcomeScreenRowUpdate, setEditWelcomeScreenRowUpdate] = useState(true);
  const [createWelcomeScreenSuccessMsg, setCreateWelcomeScreenSuccessMsg] = useState('');
  const [editWelcomeScreenSid, setEditWelcomeScreenSid] = useState("");
  const [loader, setLoader] = useState(false);
  const [fileError, setFileError] = useState("");
  const [videoFileError, setVideoFileError] = useState("");
  const [files, setFiles] = useState('');
  const [fileUrl, setFileUrl] = useState('');
  const [videoFiles, setVideoFiles] = useState('');
  const [videoFileUrl, setVideoFileUrl] = useState('');
  const [imageResetData, setImageResetData] = useState('');
  const [sequenceResetData, setSequenceResetData] = useState('');
  const [videoResetData, setVideoResetData] = useState('');
  const [sequenceOrder, setSequenceOrder] = useState('image');
  const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  const [flag, setFlag] = useState(false);
  const [roomTypesMaster, setRoomTypesMaster] = useState([]);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState('');
  const [showDeleteVideoPopUp, setShowDeleteVideoPopUp] = useState(false);
  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const [roomNoShowPopUp, setRoomNoShowPopUp] = useState(false);
  const [rowData, setRowData] = useState(false);

  const recordsPerPage = 10;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control
  } = useForm({
    mode: 'onChange',
  });
  const { chainId } = useSelector((state) => state.chainIdReducer);
  let validPermissionClassName = isValidRole("CUSTOMIZE_WELCOME_SCREEN_MODIFY")
    ? ""
    : "btn-disable-permission";

    const customizeWelcomeScreenImage = [
      {
        name: "Customize Welcome Screen Image",
        files: 1,
        size: "700 KB",
        height: 1080,
        width: 1920,
        resolution: "72 PPI",
        aspect: "16:09",
        formats: "JPG, JPEG, PNG",
      }
    ]

    const customizeWelcomeScreenVideo = [
      {
        name: "Customize Welcome Screen Video",
        files: 1,
        size: "1 GB",
        height: 1080,
        width: 1920,
        // resolution: "72 PPI",
        aspect: "16:09",
        formats: "MP4",
      }
    ]

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });

  const SELECT_ALL = { label: 'Select All', selectAll: true };

  const allOptions =  roomTypesMaster.length > 0 ? [SELECT_ALL, ...roomTypesMaster] : roomTypesMaster;

  const onSubmit = (data) => {
    if (fileUrl === '') {
      setFileError('Upload image required');
      return;
    }
    if (fileError !== "" || videoFileError !== "") {
      return;
    }
    const formData = new FormData();
    formData.append('welcomeImage', files);
    if (videoFileUrl !== "") {
      formData.append('video', videoFiles);
    }
    let method = "POST";
    let url = `/customize-screen?sequenceNo=${sequenceOrder !== "image"}&isPublished=true&text=${data?.text}&roomNumber=${data?.roomNumber}&videoLoopCount=3`;
    if (editWelcomeScreenRowUpdate) {
      method = "PUT"
      url = `/customize-screen?sid=${editWelcomeScreenSid?.sid}&sequenceNo=${sequenceOrder !== "image"}&isPublished=false&text=${data?.text}&roomNumber=${data?.roomNumber}&videoLoopCount=3`;
    }
    setLoader(true);
    callAPI(url, method, formData, { chainId: getChainIdLS() })
      .then(function (response) {
        setLoader(false);
        // reset({
        //   text: '',
        //   roomNumber: []
        // });
        // setFileUrl('');
        // setFiles('');
        // setVideoFileUrl('');
        // setVideoFiles('');
        setCreateWelcomeScreenSuccessMsg(response?.message);
        welcomeScreenListApi();
        // setEditWelcomeScreenSid('');
      })
      .catch(function (error) {
        setLoader(false);
        console.warn(error.response?.data?.errorMessage);
      });
  };

  // const onSave = (data) => {
  //   if (fileUrl === '') {
  //     setFileError('Upload image required');
  //     return;
  //   }
  //   if (fileError !== "" || videoFileError !== "") {
  //     return;
  //   }
  //   const formData = new FormData();
  //   formData.append('welcomeImage', files);
  //   if (videoFileUrl !== "") {
  //     formData.append('video', videoFiles);
  //   }
  //   setLoader(true);
  //   let method = "POST";
  //   let url = `/customize-screen?sequenceNo=${sequenceOrder !== "image"}&isPublished=false&text=${data?.text}&roomNumber=${data?.roomNumber}&videoLoopCount=${videoFileUrl !== "" ? data?.videoLoopCount : 1}`;
  //   callAPI(url, method, formData, { chainId: getChainIdLS() })
  //     .then(function (response) {
  //       setLoader(false);
  //       reset({
  //         text: '',
  //         roomNumber: []
  //       });
  //       setFileUrl('');
  //       setFiles('');
  //       setVideoFileUrl('');
  //       setVideoFiles('');
  //       setCreateWelcomeScreenSuccessMsg(response?.message);
  //       welcomeScreenListApi();
  //     })
  //     .catch(function (error) {
  //       setLoader(false);
  //       console.warn(error.response?.data?.errorMessage);
  //     });
  // };
  const isWelcomeScreenDeletedRef = useRef({
    isWelcomeScreenDeletedModalData: null,
    userConformationModalData: null,
  });

  const isWelcomeVideoDeletedRef = useRef({
    isWelcomeVideoDeletedModalData: null,
    userConformationVideoModalData: null,
  });

  const deleteWelcomeScreenConfigPopUpHandler = (row) => {
    setDeleteWelcomeScreenPopUp(true);
    const newModalRefData = {
      isWelcomeScreenDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isWelcomeScreenDeletedRef.current = newModalRefData;
  }

  const handleDeleteVideoAPI = (row) => {
    setShowDeleteVideoPopUp(true);
    const newModalRefData = {
      isWelcomeVideoDeletedModalData: {
        row
      },
      userConformationVideoModalData: null,
    };
    isWelcomeVideoDeletedRef.current = newModalRefData;
  }

  const deleteWelcomeScreenVideoHandler = () => {

    const { row } = isWelcomeVideoDeletedRef.current?.isWelcomeVideoDeletedModalData;
    callAPI(`/customize-screen-id?sid=${row?.sid}`, "DELETE")
      .then((response) => {
        let successMessage = response.message
        const newModalRefData = {
          isWelcomeVideoDeletedModalData: null,
          userConformationVideoModalData: {
            successMessage
          },
        };
        isWelcomeVideoDeletedRef.current = newModalRefData;
        welcomeScreenListApi();
      })
      .catch((error) => {
        console.warn(error)
      });

    reset({
      text: '',
      roomNumber: []
    });
    setFileUrl('');
    setFiles('');
    setVideoFileUrl('');
    setVideoFiles('');
  }

  const deleteWelcomeScreenHandler = () => {
    setConfirmValidate(true);
    if (confirmDeleteWelcomeScreenRow === "") {
      return
    }

    if (confirmDeleteWelcomeScreenRow === `Delete ${isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData.row.text}`) {
      setConfirmValidate(false)
      const { row } = isWelcomeScreenDeletedRef.current?.isWelcomeScreenDeletedModalData;
      callAPI(`/customize-screen?sid=${row?.sid}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isWelcomeScreenDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isWelcomeScreenDeletedRef.current = newModalRefData;
          welcomeScreenListApi();
        })
        .catch((error) => {
          console.warn(error)
        });
    }
    reset({
      text: '',
      roomNumber: []
    });
    setFileUrl('');
    setFiles('');
    setVideoFileUrl('');
    setVideoFiles('');
  }


  const publishUnPublishPopUpHandler = (row) => {
    setPublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishModalData: {
        message: `Do you really want to ${row?.published ? 'Un-Publish' : 'Publish'} the Customize Welcome Screen?`,
        row
      }
    };
    isPublishedUnPublishedRef.current = newModalRefData;
  }

  const renderActionIcon = (row) => {
    return (
      row?.createdBy === "Default" ? <Tooltip title="Edit" arrow>
        <MdModeEditOutline
          className="edit-icon-enable"
          onClick={() => { setEditWelcomeScreen(true); setEditWelcomeScreenSid(row) }}
        />
      </Tooltip> : (row?.createdBy === "checkin" || row?.createdBy === "PMS") ? <>
        <Tooltip title="This auto generated configuration is non editable">
          <span>
            <MdModeEditOutline className="edit-icon-disable" arrow />
          </span>
        </Tooltip>
        <Tooltip title="This auto generated configuration is non editable">
          <DeleteIcon className="delete-icon-disable" arrow />
        </Tooltip>
        <Tooltip title="This auto generated configuration is non editable" className="cursor-pointer" arrow>
          <span>
            <button type="button"
              disabled={true}
              className={`ms-3 opacity-50 ${row?.published ? 'un-published' : 'published'} ${validPermissionClassName}`}
            // onClick={() => publishUnPublishPopUpHandler(row)}
            >
              {row?.published ? 'Un-Publish' : 'Publish'}
            </button>
          </span>
        </Tooltip>
      </> : <>
        {isValidRole("CUSTOMIZE_WELCOME_SCREEN_MODIFY") ? <>
          {!row?.published ? <>
            <Tooltip title="Edit" arrow>
              <MdModeEditOutline
                className="edit-icon-enable"
                onClick={() => { setEditWelcomeScreen(true); setEditWelcomeScreenSid(row) }}
              />
            </Tooltip>
            <Tooltip title="Delete" className="cursor-pointer" arrow>
              <DeleteIcon
                className="delete-icon-enable"
                onClick={() => {
                  deleteWelcomeScreenConfigPopUpHandler(row);
                }}
              />
            </Tooltip>
          </> : <>
            <Tooltip title="Un-Publish to perform actions">
              <span>
                <MdModeEditOutline className="edit-icon-disable" arrow />
              </span>
            </Tooltip>
            <Tooltip title="Un-Publish to perform actions">
              <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
          </>
          }
          <Tooltip title={`${row?.published ? 'Un-Publish' : 'Publish'}`} className="cursor-pointer" arrow>
            <button type="button"
              className={`ms-3 ${row?.published ? 'un-published' : 'published'}`}
              onClick={() => publishUnPublishPopUpHandler(row)}
            >
              {row?.published ? 'Un-Publish' : 'Publish'}
            </button>
          </Tooltip>
        </> :
          <>
            <Tooltip title="Don't have permission to edit">
              <span>
                <MdModeEditOutline className="edit-icon-disable" arrow />
              </span>
            </Tooltip>
            <Tooltip title="Don't have permission to delete">
              <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
            <Tooltip title="Don't have permission to edit" className="cursor-pointer" arrow>
              <span>
                <button type="button"
                  className={`ms-3 ${row?.published ? 'un-published' : 'published'} ${validPermissionClassName}`}
                // onClick={() => publishUnPublishPopUpHandler(row)}
                >
                  {row?.published ? 'Un-Publish' : 'Publish'}
                </button>
              </span>
            </Tooltip>
          </>
        }</>);
  };

  const renderVideoPreview = (row) => {
    return row?.videoUrl ? <div className="screen-saver-video d-flex">
      <video width="400" controls={false} preload="metadata" onClick={() => setShowPreviewPopUp(row?.videoUrl)}>
        <source src={`${row?.videoUrl}#t=0.1`} type="video/mp4" />
      </video>
      {!row?.published ? <Tooltip title={`${editWelcomeScreenSid?.sid === row?.sid ? 'Cancel edit mode to perform actions' : 'Delete'}`}>
        <span className={`${editWelcomeScreenSid?.sid === row?.sid ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => editWelcomeScreenSid?.sid === row?.sid ? "" : handleDeleteVideoAPI(row)}>X</span></Tooltip> : <Tooltip title="Un-Publish to perform actions"><span className="cross-mark-disabled">X</span></Tooltip>}
    </div> : "NA"
  }

  const renderRoomNo = (row) => {
    const item = row?.roomDetailStatus;
    return row?.roomDetailStatus?.length > 3 ? <span className="cursor-pointer" onClick={() => { setRoomNoShowPopUp(true); setRowData(row) }}>{item?.slice(0, 3)?.map((items, index) =>
      <span >{index ? ',' : ''} {items?.roomNo}</span>
    )} {item?.length > 3 && (
      <><span>...</span><span className="ms-2 cdsn-count">+{item?.length - 3}</span></>
    )}</span> : (
      <div>{item?.map((items, index) =>
        <span >{index ? ',' : ''} {items?.roomNo}</span>
      )}</div>
    )
  }

  const columns = [
    { field: "createdDate", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "text", headerName: "Config Name", flex: 1 },
    { field: "roomNumber", headerName: "Room Number", flex: 1, row: true, renderCell: renderRoomNo },
    { field: 'imageUrl', headerName: 'Image Preview', flex: 1, row: true, renderCell: (row) => (<img src={row?.imageUrl} alt={row?.sid} className="background-config-img" onClick={() => setShowPreviewPopUp(row?.imageUrl)} />), disableSortIcon: true, },
    {
      field: 'videoUrl', headerName: 'Video Preview', flex: 1, row: true, renderCell: renderVideoPreview, disableSortIcon: true,
    },
    // {
    //   field: "actionCell",
    //   row: true,
    //   headerName: "Actions",
    //   flex: 0.5,
    //   renderCell: renderActionIcon,
    //   sortDirection: false,
    //   disableSortIcon: true,
    // },
  ];

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  const welcomeScreenListApi = () => {
    // const apiPath = `banner/search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(`/customize-screen-search?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`, "POST", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setWelcomeScreenList(response?.customizedScreenResponse)
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("")
      })
      .catch((err) => console.warn(err.message));
  };

  useEffect(() => {
    welcomeScreenListApi();
  }, [selectedPage, chainId]);

  useEffect(() => {
    callAPI("/get-room-no", "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setRoomTypesMaster(res);
      })
      .catch((err) => {
        console.warn(err.message);
      });
    cancelWelcomeScreenHandler()
  }, [chainId]);

  const popupCloseHandler = () => {
    setDeleteWelcomeScreenPopUp(false);
    setShowDeleteVideoPopUp(false);
    setRoomNoShowPopUp(false)
    setRowData(false)
  };


  useEffect(() => {
    if (editWelcomeScreen) {
      getWelcomeScreenListSidHandler();
      setEditWelcomeScreen(false);
    }
    ScrollToTop();
    setFileError('');
    setVideoFileError('');
  }, [editWelcomeScreen]);

  const getWelcomeScreenListSidHandler = () => {
    setLoader(true);
    callAPI(`/customize-screen-search?pageNo=${1}&recordsPerPage=${10}`, "POST", { "active": true }, { chainId: getChainIdLS() })
          .then((responseDefault) => {
            let defaultData = {}
            if(responseDefault?.customizedScreenResponse?.length){
              defaultData = responseDefault?.customizedScreenResponse[0]
              setEditWelcomeScreenSid(defaultData)
            }
            else{
              setCreateWelcomeScreenSuccessMsg("Please create Default Welcome Screen configuration first")
              setLoader(false);
              return
            }
            const listApi = `/customize-screen-id?sid=${defaultData?.sid}`
            callAPI(listApi, "GET")
      .then(function (response) {
        const payload = {
          text: response?.text,
          roomNumber: response?.roomDetailStatus?.map(item => item?.roomNo),
          videoLoopCount: response?.videoLoopCount
        };
        setSequenceOrder(response?.sequence === false ? 'image' : 'video');
        setFileUrl(response?.imageUrl);
        setVideoFileUrl(response.hasOwnProperty('videoUrl') ? response?.videoUrl : '');
        reset(payload);
        setImageResetData(response?.imageUrl);
        setSequenceResetData(response?.sequence === false ? 'image' : 'video');
        setVideoResetData(response.hasOwnProperty('videoUrl') ? response?.videoUrl : '');
        setEditWelcomeScreenRowUpdate(true);
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
          })
    .catch((err) => console.warn(err.message));
  }

  const resetLayoutHandler = () => {
    reset();
    setFileUrl(imageResetData);
    setSequenceOrder(sequenceResetData);
    setVideoFileUrl(videoResetData);
    setFileError('');
    setVideoFileError('');
  }

  const cancelWelcomeScreenHandler = () => {
    reset({
      text: '',
      roomNumber: []
    });
    setFileUrl('');
    setFiles('');
    setVideoFileUrl('');
    setVideoFiles('');
    setFileError('');
    setVideoFileError('');
    setEditWelcomeScreenRowUpdate(false);
    setEditWelcomeScreenSid('');
    setEditWelcomeScreen(false);
  }

  const imageUploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / 1024).toFixed(2);
    setFileUrl(URL.createObjectURL(fileList));
    if (bytes > 700) {
      setFileError('Upload file should be less than 700KB');
      return;
    }
    setFiles(fileList);
    setFileError('');
  }
  const deleteLogoHandler = () => {
    setFiles('');
    setFileUrl('');
    setFileError('');
  };

  const videoUploadOrDragFileHandler = (fileList) => {
    let bytes = (fileList.size / (1024 * 1024 * 1024)).toFixed(2);
    setVideoFileUrl(URL.createObjectURL(fileList));
    if (bytes > 1) {
      setVideoFileError('Upload file should be less than 1GB');
      return;
    }
    setVideoFiles(fileList);
    setVideoFileError('');
  }
  // const videoDeleteLogoHandler = () => {
  //   setVideoFiles('');
  //   setVideoFileUrl('');
  // };

  const publishUnPublishHandler = () => {
    const apiPath = `/customize-screen-publish?isPublish=${!(isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published)}&Id=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.sid}&roomNo=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.roomDetailStatus?.map(item => item?.roomNo)}`;
    setLoader(true);
    callAPI(apiPath, "POST", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setFlag(!flag)
        let successMessage = res.message
        const newModalRefData = {
          isPublishUnPublishModalData: {
            message: successMessage
          }
        };
        isPublishedUnPublishedRef.current = newModalRefData;
        welcomeScreenListApi();
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setPublishUnPublishPopUp(false);
        setLoader(false);
      });
  }

  return (
    <div className='row config-hotel config-management-form'>
      <div className='col-12 left-column'>
        {loader && <div className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p className="Roboto-Bold">{"Assign welcome screen on Rooms"}</p>
            </div>
            <div className="form-group-hotel col-6">
              <div className="floating-label">
                <FaImage className="new-hotel-icons" />
                <input
                  id="text"
                  disabled={true}
                  maxLength={25}
                  placeholder=""
                  {...register("text", {
                    required: "Config Name Required",
                  })}
                />
                <label htmlFor="text">Config Name</label>
              </div>
              {errors.text && (
                <small className="required">{errors.text.message}</small>
              )}
            </div>
            <div className="col-6 form-group-hotel">
      <div className="floating-select-label">
        <Controller
          name="roomNumber"
          control={control}
          rules={{
            validate: value =>
              Array.isArray(value) && value?.length > 0 || 'Please Select Room Number',
          }}
          render={({ field }) => (
            <Autocomplete
              {...field}
              multiple
              limitTags={6}
              disablePortal
              options={allOptions}
              getOptionLabel={(option) =>
                option?.selectAll ? option.label : option.toString()
              }
              value={field.value || []}
              onChange={(_, selected) => {
                const isSelectAllSelected = selected.some(opt => opt?.selectAll);
                if (isSelectAllSelected) {
                  // If "Select All" was just selected, check if all were already selected
                  if ((field.value || []).length === roomTypesMaster.length) {
                    // Deselect all
                    field.onChange([]);
                  } else {
                    // Select all
                    field.onChange([...roomTypesMaster]);
                  }
                } else {
                  // Regular selection
                  field.onChange(selected);
                }
              }}
              disableCloseOnSelect
              className={`multiselectlist ${
                field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''
              }`}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={
                      option?.selectAll
                        ? (field.value || []).length === roomTypesMaster.length
                        : selected
                    }
                  />
                  {option?.label || option.toString()}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder=""
                  variant="outlined"
                  label="Select Room Number"
                  InputLabelProps={{
                    shrink: false,
                  }}
                />
              )}
            />
          )}
        />
      </div>
      {errors.roomNumber && (
        <small className="required">{errors.roomNumber?.message}</small>
      )}
    </div>
            {fileUrl && <div className={`form-group-hotel ${videoFileUrl?"col-6":"col-12"}`}>
              {fileUrl !== "" ? <div className="partner-logo">
                <img src={fileUrl} alt={fileUrl} />
                {/* {editWelcomeScreenSid?.createdBy !== "Default" && <span onClick={() => deleteLogoHandler()}>X</span>} */}
              </div>
                : <FileUploader
                  name="file"
                  types={["JPG", "PNG", 'JPEG']}
                  handleChange={imageUploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop image or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Image</span> here.
                      <ImageResolutionTooltip data={customizeWelcomeScreenImage}/>
                      </p>
                      {/* <h6> Formats Supported : JPG, JPEG and PNG</h6> */}
                      <p className="fnt-12px mb-0">Please check the resolution of your television and the welcome letter for better viewing experience</p>
                    </>
                  }
                />
              }

              {fileError && <p className="required">{fileError}</p>}
            </div>}
            {videoFileUrl && <div className={`form-group-hotel ${fileUrl?"col-6":"col-12"}`}>
              {videoFileUrl !== "" ? <div className="partner-logo">
                <video className="col-12" controls key={videoFileUrl}>
                  <source src={videoFileUrl} type={videoFileUrl?.type} />
                  Your browser does not support the video tag.
                </video>
                {/* {editWelcomeScreenSid?.createdBy !== "Default" && <span className="re-upload-icon">
                  <FileUploader
                    name="file"
                    types={["MP4"]}
                    handleChange={videoUploadOrDragFileHandler}
                    classes="re-upload-file"
                    children={<FaArrowsRotate />}
                  />
                </span>} */}
              </div>
                : <FileUploader
                  name="file"
                  types={["MP4"]}
                  handleChange={videoUploadOrDragFileHandler}
                  classes="drag-file file-upload-bg"
                  children={
                    <>
                      <FontAwesomeIcon icon={faImages} className="fa-lg" />
                      <p className="drag-text">
                        Drag and drop video or
                        <span> Browse</span>
                        <br />
                        To upload <span className="Roboto-Bold text-black">Video</span> here.
                        <ImageResolutionTooltip data={customizeWelcomeScreenVideo}/>
                      </p>
                      {/* <h6> Formats Supported : MP4</h6> */}
                      <p className="pb-1"></p>
                    </>
                  }
                />
              }
              {videoFileError && <p className="required">{videoFileError}</p>}
            </div>}
            {/* {editWelcomeScreenSid?.createdBy === "Default" && <div className="createdby-default">
              <span>Note: </span> For default configuration image and video is non changeable
            </div>} */}
            {/* {videoFileUrl !== "" && <div className="col-4 status-switch form-group-hotel">
              <p className="mb-1">Video Loop count</p>
              <div className="floating-select-label">
                <Controller
                  name="videoLoopCount"
                  defaultValue={3}
                  control={control}
                  rules={{ required: "Loop count is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <Autocomplete
                      {...field}
                      className={`multiselectlist ${field.value ? 'Mui-focused' : ''}`}
                      disablePortal
                      options={[1, 2, 3, 4, 5]}
                      getOptionLabel={(option) => option.toString()}
                      onChange={(_, newValue) => {
                        field.onChange(newValue);
                        // handleMetadataChange(newValue, "selectionType");
                      }}
                      value={field.value || 1}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder=""
                          variant="outlined"
                          label="Loop Count"
                          InputLabelProps={{
                            shrink: false,
                          }}
                        />
                      )}
                    />
                  )}
                />
              </div>
            </div>} */}
          </div>
          <div className="text-end mt-3">
            <button type="button" className="clear-btn me-2" onClick={cancelWelcomeScreenHandler}>{editWelcomeScreenRowUpdate ? "Cancel" : "Clear All"}</button>
            {editWelcomeScreenRowUpdate && <>
              <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
            </>}
            {/* {!editWelcomeScreenRowUpdate && <button type="button" onClick={handleSubmit(onSave)} className={`disable-btn me-2 ${validPermissionClassName}`}>Save</button>} */}
            <button type="button" onClick={handleSubmit(onSubmit)} className={`create-btn ${validPermissionClassName}`}>{editWelcomeScreenRowUpdate ? "Update" : "Publish"}</button>
          </div>
        </form>
        {/* <div className="hotel-list">
          <p><b>Customize Welcome Screen List</b></p>

          <TableWrapper
            data={welcomeScreenList}
            columns={columns}
            noPagination={true}
            module="customize-welcome-screen"
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div> */}
      </div>
      {deleteWelcomeScreenPopUp && <DeleteBackgroundImage
        deleteWelcomeScreenPopUp={deleteWelcomeScreenPopUp}
        isWelcomeScreenDeletedRef={isWelcomeScreenDeletedRef}
        popupCloseHandler={popupCloseHandler}
        deleteWelcomeScreenHandler={deleteWelcomeScreenHandler}
        setConfirmDeleteWelcomeScreenRow={setConfirmDeleteWelcomeScreenRow}
        confirmDeleteWelcomeScreenRow={confirmDeleteWelcomeScreenRow}
        confirmValidate={confirmValidate}
      />}
      {showDeleteVideoPopUp && <CustomizeWelcomeVideoDelete
        showDeleteVideoPopUp={showDeleteVideoPopUp}
        popupCloseHandler={popupCloseHandler}
        isWelcomeVideoDeletedRef={isWelcomeVideoDeletedRef}
        deleteWelcomeScreenVideoHandler={deleteWelcomeScreenVideoHandler}
      />}
      <BasicModal
        popupOpen={createWelcomeScreenSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createWelcomeScreenSuccessMsg}</p>}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreateWelcomeScreenSuccessMsg(''); setEditWelcomeScreenRowUpdate(false); welcomeScreenListApi(); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      {showPreviewPopUp !== "" && <PreviewBgImage
        showPreviewPopUp={showPreviewPopUp}
        setShowPreviewPopUp={setShowPreviewPopUp}
      />}
      <BasicModal
        popupOpen={publishUnPublishPopUp}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<>
          {isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData && <p className="mt-2">{isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message}</p>}
        </>
        }
        footer={
          isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Publish the Customize Welcome Screen?" ||
            isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Un-Publish the Customize Welcome Screen?" ? {
            primaryButton: {
              buttonName: "Cancel",
              action: () => setPublishUnPublishPopUp(false)
            },
            secondaryButton: {
              buttonName: isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.published ? 'Un-Publish' : 'Publish',
              action: publishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: () => setPublishUnPublishPopUp(false)
            }
          }
        }
      />
      <BasicModal
        popupOpen={roomNoShowPopUp}
        bodyMessage={
          <div className="text-start">
            <p className="px-3 pt-3">List of "<b>{rowData?.text}</b>" Linked Room Number.</p>
            <div className="linked-sid-cdsns">
              <div className="sid-cdsn-list">
                <div className="row sid-cdsn-list-header">
                  <h6 className="text-start">Room Numbers.</h6>
                </div>
                {rowData?.roomDetailStatus?.map((items, index) =>
                  <span className="sx-1 mb-1">{index ? ',' : ''} {items?.roomNo}</span>
                )}
              </div>
            </div>
          </div>
        }
        customcss={true}
        footer={
          {
            primaryButton: {
              buttonName: "Cancel",
              action: popupCloseHandler,
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
    </div>
  )
}

export default CustomizeWelcomeScreen;